module.exports = __webpack_public_path__ + "assets/push-gift-09d6025a.png";